import { render, staticRenderFns } from "./LmsDashboard.vue?vue&type=template&id=5fc05aa8&"
import script from "./LmsDashboard.vue?vue&type=script&lang=js&"
export * from "./LmsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LmsDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports